__turbopack_context__.v({
  "className": "jetbrains_mono_85243f4a-module__eb-CGW__className",
  "variable": "jetbrains_mono_85243f4a-module__eb-CGW__variable",
});
